import React from "react";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import TextButton from "../../../app/components/buttons/text";

export default function TopControls() {
  const { id } = useParams();
  const navigate = useNavigate();

  const handleBackStudyActual = () => {
    navigate(`/ctpo/study-actuals/${id}`);
  };

  return (
    <Container>
      <TextButton onClick={handleBackStudyActual}>
        <ChevronLeftIcon />
        Back
      </TextButton>
    </Container>
  );
}

const Container = styled.div`
  padding-block: 1.5rem;
`;
